@if (visible()) {
  <div class="consent-banner" role="dialog" aria-label="Analytics consent">
    <div class="consent-banner__content">
      <p class="consent-banner__text">
        We use analytics to improve your experience. Do you consent to anonymous usage tracking? See
        our
        <a
          class="consent-banner__link"
          href="https://locumsnest.co.uk/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
        for details.
      </p>
      <div class="consent-banner__actions">
        <button
          class="consent-banner__btn consent-banner__btn--decline"
          type="button"
          (click)="decline()"
        >
          Decline
        </button>
        <button
          class="consent-banner__btn consent-banner__btn--accept"
          type="button"
          (click)="accept()"
        >
          Accept
        </button>
      </div>
    </div>
  </div>
}
